import { SET_TEST_MODE } from './types';

export const setTestMode = testMode => ({
  type: SET_TEST_MODE,
  testMode,
});

export default setTestMode;
